<!-- 奖罚记录 -->
<template>
    <div v-loading="loading" id="rewardAndPRecordDetail">
        <div class="searchAp-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="flex">
                        <div class="search-name">员工</div>
                        <div>
                            <el-select v-model="searchData.SId" filterable clearable remote size="small" placeholder="选择业务员" style="width: 100%">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </div>
                        <div class="search-name">奖罚时间</div>
                        <el-date-picker
                            class="search-name"
                            v-model="dateTimes"
                            type="daterange"
                            align="right"
                            size="small"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="handleChange"
                        >
                        </el-date-picker>
                        <div class="search-name">
                            <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                            <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                            <el-button class="btn-primary" size="small" icon="el-icon-plus" v-if="permission.addrandprecord" @click="showAddRecordDialog()">
                                {{ permission.addrandprecord }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    ref="multipleTable"
                    height="470px"
                    style="width: 100%; margin-bottom: 10px"
                    :default-sort="{ prop: 'AllAmount', order: 'descending' }"
                >
                    <el-table-column show-overflow-tooltip width="120" prop="Name" label="员工"></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip label="奖罚类型">
                        <template slot-scope="scope">{{ scope.row.Type | typeHandle }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="Score" label="分数"></el-table-column>
                    <el-table-column show-overflow-tooltip width="160" prop="Date" label="奖罚时间"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="150" prop="Reason" label="奖罚原因"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="150" prop="Remark" label="备注"></el-table-column>
                    <el-table-column show-overflow-tooltip width="160" prop="UpdateTime" label="最后更新时间"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="85px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button v-if="permission.editrandprecord" title="编辑该条赏罚明细" size="mini" type="text" @click="showEditRecordDialog(scope.row)"
                                    >编辑</el-button
                                >
                                <el-button v-if="permission.delrandprecord" title="删除该条赏罚明细" size="mini" type="text" @click="delRecord(scope.row)">删除</el-button>
                            </div>
                        </template></el-table-column
                    >
                </el-table>
            </div>
            <div class="dialog-pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <!--    新增/编辑奖罚记录    -->
            <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="editVisible" :append-to-body="true" width="800px">
                <div class="dialog-content" v-if="editVisible">
                    <rewardAndPRecordEdit :RecordData="recordData" @closeDialog="closeEdit"></rewardAndPRecordEdit>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import rewardAndPRecordEdit from '@/components/business/msgSetting/rewardAndPRecordEdit';
export default {
    name: '',
    props: {
        StaffId: {
            Type: String
        },
        OrgId: {
            Type: String
        }
    },
    components: { rewardAndPRecordEdit },
    data() {
        return {
            dateTimes: '',
            title: '',
            editVisible: false,
            recordData: {},
            loading: false,
            orgId: '',
            searchData: {
                SId: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10,
                EntpId: this.$util.getLocalStorage('userMsg').EntpId
            },
            tableData: [],
            SIdList: [],
            tableDataLength: 0,
            permission: {} //该页面的权限
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('staffManagement');
        this.getSIdList();
        this.getTableData();
        this.searchData.SId = this.StaffId;
        this.orgId = this.OrgId;
        let dialogbody = document.querySelector('#rewardAndPRecordDetail');
        this.$util.setEventForDialog(this, dialogbody);
    },
    filters: {
        typeHandle(value) {
            if (value == 0) {
                return '奖赏';
            } else if (value == 1) {
                return '惩罚';
            }
        }
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        resetSearch() {
            this.dateTimes = '';
            this.searchData = {
                SId: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10,
                EntpId: this.searchData.EntpId
            };
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetStaffRAndPRecords',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        showAddRecordDialog() {
            this.title = '添加赏罚记录';
            this.recordData = {};
            this.recordData.OrgId = this.orgId;
            this.recordData.SId = this.StaffId;
            this.editVisible = true;
        },
        showEditRecordDialog(item) {
            this.title = '编辑赏罚记录';
            this.recordData = item;
            this.editVisible = true;
        },
        closeEdit() {
            this.editVisible = false;
            this.getTableData();
        },
        delRecord(item) {
            let that = this;
            that.$util.elConfirm({
                content: '是否删除该员工的奖赏记录?',
                confirmMsg: '成功删除该条奖赏记录！',
                confirm() {
                    that.loading = true;
                    that.$util
                        .axiosGet({
                            url: '/api/EntpInfoManagement/DeleteStaffRAndPRecord',
                            data: {
                                StaffId: item.SId,
                                UserId: that.$util.getLocalStorage('userMsg').EmployeeId,
                                RecordId: item.Id
                            },
                            hideLoading: true
                        })
                        .then(() => {
                            that.getTableData();
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    height: 600px;
    overflow-y: auto;
}
</style>
